"use client";
'use strict';

var React = require('react');

/**
 * React hook that manage state with callback on change
 *
 * @param initialState
 * @example
 * ```
 * const [innerValue, setInnerValue] = useStateCallback<string | number | Array<string | number> | undefined>(value)
 *
 * setInnerValue(data, (val) => {
 *   safeInvoke(onChange, val)
 * })
 * ```
 */
function useStateCallback(initialState) {
    const [state, _setState] = React.useState(initialState);
    const callbackRef = React.useRef();
    const isFirstCallbackCall = React.useRef(true);
    const setState = React.useCallback((setStateAction, callback) => {
        callbackRef.current = callback;
        _setState(setStateAction);
    }, []);
    React.useEffect(() => {
        if (isFirstCallbackCall.current) {
            isFirstCallbackCall.current = false;
            return;
        }
        callbackRef.current?.(state);
    }, [state]);
    return [state, setState];
}

exports.useStateCallback = useStateCallback;
//# sourceMappingURL=useStateCallback.js.map
